<div class="eidos-field">{{getColumnLookupValue()}}</div>
